export default "__VITE_ASSET__BK0wmHEj__"